module.exports = __webpack_public_path__ + "img/qr-code.d03a04c2.svg";